import { render, staticRenderFns } from "./GroupsView.vue?vue&type=template&id=4779b96a"
import script from "./GroupsView.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports